import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "29dc2ce3-b332-4345-8179-eaa86d506b23",
    content: "A simple, lightweight drywall",
    options: { image: `${config.ASSETS_URL}/05/18/task/task-3-item-1.svg` },
  },
  {
    id: "4e8bca56-fa3b-4c9d-af3b-afcdf801ef8f",
    content: "A massive concrete wall",
    options: { image: `${config.ASSETS_URL}/05/18/task/task-3-item-2.svg` },
  },
  {
    id: "bb428c5f-a8b6-4ece-a393-2d5e002a2792",
    content: "A corrugated sheet-metal wall",
    options: { image: `${config.ASSETS_URL}/05/18/task/task-3-item-3.svg` },
  },
];

export const task: Task = {
  id: "27195003-e35e-4414-b521-0fddfe89608f",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 3,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4e8bca56-fa3b-4c9d-af3b-afcdf801ef8f"],
};
